import { useNavigate } from 'react-router-dom';
// import { findNotificationsPreferencesByUserId } from '../../../services/on-boarding/onboarding.service';
import { useCallback } from 'react';
import { getAuthentication } from '../../../hooks/useAuthentication';

export default function useMarkStepDone() {
  const navigate = useNavigate();

  const markStepDone = async (stepUrl: string) => {
    const { user } = getAuthentication();
    localStorage.setItem(`current-step-${user?.id}`, stepUrl);
  };

  const onBoardingCompleted = async () => {
    localStorage.removeItem(`current-step-${getAuthentication()?.user?.id}`);
  };

  const checkCurrentStep = useCallback(async () => {
    const authentication = getAuthentication();
    const currentStep = localStorage.getItem(`current-step-${authentication?.user?.id}`);
    if (!currentStep) {
      // const preferences = await findNotificationsPreferencesByUserId(authentication?.user?.id || '');
      // if (preferences?.length) {
      //   navigate('/');
      // }
    }
    const isUrlIsTheSame = currentStep === window.location.pathname;

    if (isUrlIsTheSame || !currentStep) {
      return;
    }
    navigate(currentStep || '/');
  }, [navigate]);

  return {
    markStepDone,
    onBoardingCompleted,
    checkCurrentStep,
  };
}
